import React from "react";
import _ from "underscore"
import { getSurveysStats } from "../../actions/surveys";
import { getDefaultState, SurveysStore } from "../../stores/surveys";
import { connect } from "../../utils/aj-react";
import QuickStats from "./quickStats";



export class EvaluationsGridHeader extends React.Component {

    constructor(props) {
        super(props);
        
        connect(this, SurveysStore, getDefaultState());
    }

    componentDidMount(){
        this.getData();
    }

    getData(){
        getSurveysStats({  
        })
    }

    render() { 
        const stats = this.state.surveysStats ?? [];
        return (
            <QuickStats  items={stats}/>
        )
    }
}